export const CONTRACT_STATUS_CARD_DEFAULT_TEMPLATE = {
  op: 'ui',
  name: 'Stack',
  spacing: 2,
  children: [
    {
      op: 'ui',
      name: 'Stack',
      direction: 'row',
      spacing: 1,
      justifyContent: 'space-between',
      useFlexGap: true,
      sx: { flexWrap: 'wrap' },
      children: [
        {
          op: 'ui',
          name: 'ResponsiveText',
          variant: 'h4',
          responsiveOptions: {
            minFontSize: '1.25rem',
            maxFontSize: '1.5rem',
            textLengthThreshold: 25,
          },
          children: {
            op: 'translate',
            translation: 'common:contract-management.thing-card.title.label',
          },
        },
        {
          op: 'context',
          path: 'statusChip',
        },
      ],
    },
    {
      op: 'if',
      condition: {
        op: 'context',
        path: 'plan',
      },
      then: {
        op: 'ui',
        name: 'DataRow',
        'data-testid': 'contract-status-card-plan',
        label: {
          op: 'translate',
          translation: 'common:contract-management.thing-card.plan.label',
        },
        value: {
          op: 'context',
          path: 'plan.display',
        },
      },
    },
    {
      op: 'ui',
      name: 'DataRow',
      'data-testid': 'contract-status-card-expiry-date',
      label: {
        op: 'translate',
        translation: 'common:contract-management.thing-card.expiry-date.label',
      },
      value: {
        op: 'format-timestamp',
        format: 'dateFull',
        value: {
          op: 'context',
          path: {
            op: 'if',
            condition: {
              op: 'context',
              path: 'dataSubscriptionInfo.lastDataSubscription.finish',
            },
            then: 'dataSubscriptionInfo.lastDataSubscription.finish',
            else: 'dataSubscriptionInfo.lastDataSubscription.expiry',
          },
        },
      },
    },
  ],
};
